import script from "./TheCoreData.vue?vue&type=script&setup=true&lang=js"
export * from "./TheCoreData.vue?vue&type=script&setup=true&lang=js"

import "./TheCoreData.vue?vue&type=style&index=0&id=3a4d06e9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a4d06e9"]])

export default __exports__